module.exports = __webpack_public_path__ + "static/img/ent-detail-57.8826714.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-57.jpg
// module id = 18Zk
// module chunks = 52